/*
 * @Author: liyxt
 * @Date: 2019-08-06 16:13:32
 * @LastEditors: liyxt
 * @LastEditTime: 2020-06-15 15:45:17
 * @Description: file content
 */
/* eslint-disable max-lines */
/* eslint-disable no-loop-func */
/* eslint-disable max-lines */
/* eslint-disable import/named */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
// eslint-disable-next-line max-lines
import React, { cloneElement } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
// 第三方库
import { HotKeys } from 'react-hotkeys';
// base
import FormControl from '../-FormControl';
import Col from '../Col';
import Dropdown from '../Dropdown';
// api
import { toast, getSysFieldid, ajax, getGlobalStorage } from '@platform/api';
import {
    calculateResizeContainerHeight,
    compare,
    compareArr,
    perceptionDropDownShow,
    perceptionInputContainerClass,
    handleArrowKeyDown,
} from './utils';
import DropDownOfRefer from './components/DropDownOfRefer';
import TagGroup from './components/Tag';
// 参照方法类
import Methods from './Methods';
// 多语资源
import { getMultiLang } from '@platform/api';
import { findParentTd } from '@platform/api';

// 组件
class BaseRefer extends Methods {
    constructor(props) {
        super(props);
        this.state = {
            referVal: '', // 输入框的值
            tableData: [
                {
                    rows: [],
                    page: {
                        pageIndex: 0,
                        pageSize: props.pageSize,
                        totalPage: 1,
                    },
                },
            ], // 参照的数据
            treeData: [props.rootNode], // 左树的值
            currentLevel: 0, // 当前是第几级
            dropDownList: {
                page: {
                    pageIndex: 0,
                    pageSize: props.pageSize,
                    totalPage: 1,
                },
                rows: [],
            }, // 下拉搜索和历史记录
            dropDownShow: false, // 搜索和历史记录下拉是否显示
            isShow: false, // 参照下拉和弹窗是否显示
            loading: false, // loading是否显示
            selectedValues: new Map(), // 已选的数据
            isSelectedShow: false, // 是否显示已选择
            group: { undefined: [props.rootNode] }, // 分组树数据
            jsonInsideRefer: {}, // 参照多语
            treeDataWithChildren: [], // 树形的数据结构
            historySelectionVisible: false, // 参照在表格中渲染时是否显示历史记录, 在表格中用ctrl键控制历史记录是否打开，因此需要多一个状态去记录
            searchHasMoreData: false,
            snapValue: [],
        };
        this.interval = 0;
        this._value = new Map(); // 实际已选值
        this.startIndex = 0;
        this.endIndex = 0;
        this.originGroup = {};
        this.originKeyMap = {};
    }

    componentWillMount() {
        let { autoFocus } = this.props;
        if (autoFocus) {
            this.autoFocus = true;
            this.focusFlag = true;
        }

        this.propsToState(this.props);

        let callback = jsonInsideRefer => {
            this.setState({ jsonInsideRefer });
        };
        // moduleId为所需加载json文件夹名称前缀
        getMultiLang({ moduleId: 'containers_refer', callback });
    }

    componentDidMount() {
        let { autoShow } = this.props;
        if (autoShow && typeof this.show === 'function') {
            this.show();
        }
        this.lifecycleStatus = 'mount';
        document.addEventListener('keydown', this.handleKeyDown);
        document.addEventListener('keyup', this.handleKeyUp);
    }

    componentWillReceiveProps(nextProps) {
        this.propsToState(nextProps, this.props);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.isShow === false && this.state.isShow === true) {
            // 打开
            calculateResizeContainerHeight(this.dragContainer);
        } else if (prevState.isShow === true && this.state.isShow === false) {
            // 关闭
        }

        let { idKey, rootNode } = this.props;
        let {
            expandedKeys,
            group,
            treeData,
		 } = this.state;

        // 根节点改变
	    let rootId = rootNode?.[idKey] ?? '',
	        prevRootId = prevProps.rootNode?.[prevProps.idKey] ?? '',
	        rootName = this.getDisplayOrValue(rootNode, 'display') ?? '',
	        prevRootName = this.getDisplayOrValue(prevProps.rootNode, 'display', prevProps) ?? '';
	    
        if (prevRootId !== rootId || rootName !== prevRootName) {
	        treeData = [rootNode];
	        if (Array.isArray(expandedKeys)) {
	            let i = expandedKeys.findIndex(e => e === prevRootId);
	            expandedKeys.splice(i, 1, rootId);
	        } else {
	            expandedKeys = [rootId];
	        }
	        group = { undefined: [rootNode] };

            rootNode &&
				(rootNode.refpk = rootNode.refpk || rootNode[idKey]);
	
            this.setState({
                treeData,
                expandedKeys,
                group,
            });
	    }
    }

    componentWillUnmount() {
        delete this.referInput;
        delete this.referContainer;
        delete this.hiddenInput;
        delete this.hotKeyElement;
        document.removeEventListener('keydown', this.handleKeyDown);
        document.removeEventListener('keyup', this.handleKeyUp);
    }

	handleKeyDown = e => {
	    this.shiftKey = e.shiftKey;
	    this.ctrlKey = e.ctrlKey;
	};

	handleKeyUp = () => {
	    this.shiftKey = false;
	    this.ctrlKey = false;
	};

	// 将props转化为state
	propsToState = props => {
	    let { disabled } = props,
	        value = this.getTrueValue(props);

	    if (disabled) {
	        this.setState({ dropDownShow: false });
	    }

	    // 同步props.value到state.selectedValues，保证外部输入的value和内部统一
	    // 同步referVal
	    // props.value 外部传进来的值
	    // this._value 实际选中的值（上次选中的值）
	    // state.selectedValue 当前选中的值（还没点确定）
	    let { selectedValues } = this.state;
	    let innerValue, outerValue;

	    if (props.isMultiSelectedEnabled) {
	        // 多选
	        let o = new Map();
	        Array.isArray(value) || (value = []);
	        innerValue = [...(this._value || new Map()).keys()];
	        outerValue = value.map(e => e.refpk);
	        if (!compareArr(innerValue, outerValue)) {
	            value.forEach(e => {
	                e.refpk && o.set(e.refpk, e);
	            });
	            selectedValues = o;
	            this._value = new Map(JSON.parse(JSON.stringify(selectedValues)));
	            // !isEdit && !isShowStatus && 
	            this.setState({ selectedValues, referVal: this.getDisplayOrValue(value, 'display', props) });
	        }
	    } else {
	        innerValue = [...(this._value || new Map()).keys()][0] || '';
	        outerValue = value?.refpk ?? '';
	        // 单选
	        if (innerValue !== outerValue) {
	            // 新旧值不等
	            if (value?.refpk) {
	                selectedValues = new Map(
	                    Object.entries({ [value.refpk]: value }),
	                );
	                this._value = new Map(JSON.parse(JSON.stringify(selectedValues)));
	                // !isEdit && !isShowStatus && 
	                this.setState({ selectedValues, referVal: this.getDisplayOrValue(value, 'display', props) });
	            } else {
	                // !isEdit && !isShowStatus && 
	                selectedValues = new Map();
	                this._value = new Map(JSON.parse(JSON.stringify(selectedValues)));
	                this.setState({ selectedValues, referVal: '' });
	            }
	        }
	    }
	    this.setState({
	        // selectedValues,
	        selectedKeys: this.state.selectedKeys,
	        columnConfig:
				typeof this.getColumnConfig === 'function' &&
				this.getColumnConfig(props),
	    });
	};

	refreshTip = () => {
	    if (this.refreshFlag) {
	        toast({
	            color: 'success',
	            content: this.state.jsonInsideRefer['containers-refer-0048'],
	        });
	        this.refreshFlag = false;
	    }
	}

	// 刷新
	refresh = (clearCache = true) => {
	    this.refreshFlag = true;
	    let { pageSize, rootNode, refType, idKey } = this.props,
	        { selectedKeys, paginationRefreshKey } = this.state;
	    // state数据清空
	    let defaultState = {
	        tableData: [
	            {
	                rows: [],
	                page: {
	                    pageIndex: 0,
	                    pageSize,
	                    totalPage: 1,
	                },
	            },
	        ], // 参照的数据
	        treeData: [rootNode], // 左树的值
	    };
	    // 缓存数据清空
	    this.clearCache();
	    // 树表时清除左树选中
	    if (refType === 'gridTree') {
	        selectedKeys = [];
	    }
	    // 清空搜索框
	    let newState = {
	        ...defaultState,
	        selectedKeys,
	        searchVal: '',
	        treeSearchVal: '',
	        isTreeSearch: false,
	        isSearch: false,
	        expandedKeys: [rootNode[idKey]],
	        paginationRefreshKey: ++paginationRefreshKey,
	    };
	    clearCache &&
			(newState.selectedValues = new Map(
			    JSON.parse(JSON.stringify(this._value)),
			)); // 已选恢复到点开时
	    this.setState(newState, () => {
	        // 查全部数据
	        this.show(true);
	    });
	};

	// 格式转化（单选 or 多选）：{ display, value } => {refname, refpk}
	foolValueToValue = (fool, props) => {
	    const { isMultiSelectedEnabled } = props;
	    let finalVal;
	    fool.display = fool.display || '';
	    fool.value = fool.value || '';
	    if (isMultiSelectedEnabled) {
	        let { display, value, ...arr } = fool;
	        // 多选 { display: '1,3', value: '2,4' } => [{refname: '1', refpk: '2'}, {refname: '3', refpk: '4'}]
	        let foolDisplays = fool.display.split(','),
	            foolValues = fool.value.split(',');
	        finalVal = [];
	        !foolDisplays[0] && (foolDisplays = []);
	        !foolValues[0] && (foolValues = []);
	        foolValues
	            .filter(e => e)
	            .forEach((e, i) => {
	                finalVal.push(
	                    this.foolToSmart(
	                        {
	                            ...(arr[i] || {}),
	                            display: foolDisplays[i],
	                            value: e,
	                        },
	                        props,
	                    ),
	                );
	            });
	        // finalVal = arr;
	    } else {
	        finalVal = this.foolToSmart(fool, props);
	    }

	    return finalVal;
	};

	// 格式转化（单选）：{ display, value } => {refname, refpk}
	foolToSmart = (fool, props) => {
	    let { selectedValues } = this.state;
	    let { fieldDisplayed, fieldValued, fieldSplitSep } = props;
	    fool.display = fool.display || '';
	    fool.value = fool.value || '';

	    if (selectedValues.has(fool.value)) {
	        return selectedValues.get(fool.value);
	    }

	    let foolDisplay = fool.display,
	        foolValue = fool.value,
	        smart = { ...fool };
	    if (fieldDisplayed.includes(fieldSplitSep)) {
	        // fieldDisplayed包含指定分隔符时，表示是多字段展示。
	        fieldDisplayed = fieldDisplayed.split(fieldSplitSep);
	        foolDisplay = fool.display.split('/');
	    }

	    if (foolValue) {
	        Array.isArray(fieldDisplayed)
	            ? fieldDisplayed.forEach((e, i) => {
	                smart[e] = foolDisplay[i];
				  })
	            : (smart[fieldDisplayed] = foolDisplay);
	        smart[fieldValued] = smart[fieldValued] || foolValue;
	        smart.refpk = smart.refpk || foolValue;
	        // typeof fieldDisplayed === 'string' && (smart[fieldDisplayed] = smart[fieldDisplayed] || smart[fieldValued]);
	        return smart;
	    } else {
	        return {};
	    }
	};

	// 是否命中缓存
	hasCache = (url, param) => {
	    let cacheData = ViewModel.getData('referCache') || [],
	        cache = cacheData.find(e => {
	            return e.url === url && compare(param, e.param);
	        });
	    if (cache) {
	        this.setCacheData(url, param, cache.data);
	        return cache.data;
	    } else {
	        return null;
	    }
	};

	// 将数据存入缓存
	setCacheData = (url, param, data) => {
	    param = JSON.parse(JSON.stringify(param));
	    data = JSON.parse(JSON.stringify(data));
	    let { maxCacheNum } = this.props,
	        cacheData = ViewModel.getData('referCache') || [];
	    let i = cacheData.findIndex(e => {
	        return e.url === url && compare(param, e.param);
	    });
	    if (i > -1) {
	        cacheData.splice(i, 1);
	    }

	    cacheData.push({
	        url,
	        param,
	        data,
	    });
	    while (cacheData.length > maxCacheNum) {
	        cacheData.shift();
	    }
	    ViewModel.setData('referCache', cacheData);
	};

	// 清空缓存
	clearCache = () => {
	    ViewModel.setData('referCache', []);
	};

	// 根据pk顺序排序
	sortRowsByPk = (rows, pks, checkStrictly) => {
	    let rowMap = {}, { fieldDisplayed, fieldValued } = this.props, res = [];
		
	    (rows || []).forEach(row => {
	        rowMap[row.refpk] = row;
	    });
		
	    pks.map(pk => {
	        if (rowMap[pk]) {
	            res.push(rowMap[pk]);
	        } else if (!checkStrictly) {
	            res.push({
	                refname: pk,
	                refcode: pk,
	                refpk: pk,
	                [fieldDisplayed]: pk, 
	                [fieldValued]: pk,
	            });
	        }
	    });

	    return res;
	};

	// 业务组复写：获取请求参数
	getParam = () => {
	    return {};
	};

	// 获取请求参数
	__getParam = (param = {}) => {
	    let {
	            queryCondition,
	            refType,
	            isShowUnit,
	            isShowDisabledData,
	            isHasDisabledData,
	            pk_defdoclist,
	            dataPowerOperationCode,
	            isDataPowerEnable,
	            unitProps,
	            extraParam,
	            refRelyCondition,
	            isgrouppower,
	            refcode,
	            rootNode,
	            isTreelazyLoad,
	        } = this.props,
	        { isShow, tableData } = this.state,
	        {
	            keyword = '',
	            pid = '',
	            pageInfo = {},
	            searchPks,
	            filterPks,
	            loadSelectedData = false,
	        } = param;
	    pageInfo = {
	        pageSize: pageInfo.pageSize || tableData[0].page.pageSize,
	        pageIndex: pageInfo.pageIndex || (refType === 'tree' ? -1 : 0),
	    };
	    if (pageInfo.pageSize == -1) {
	        pageInfo.pageIndex = -1;
	    }

	    let extraCondition = {};
	    !loadSelectedData &&
			unitProps &&
			isShowUnit &&
			(extraCondition[unitProps.key || 'unitPks'] =
				Array.isArray(this.state.unit) && this.state.unit.length
				    ? this.state.unit.map(e => e.refpk).join(',')
				    : (this.state.unit || {}).refpk);
	    isHasDisabledData &&
			isShowDisabledData &&
			(extraCondition.isShowDisabledData = this.state.isShowDisabledData);
	    !isShow && keyword && (extraCondition.searchFlag = true);
	    extraCondition.isShowUnit = !!isShowUnit;
	    // 模板上会返回下面几个属性
	    pk_defdoclist !== undefined &&
			(extraCondition.pk_defdoclist = pk_defdoclist);
	    dataPowerOperationCode !== undefined &&
			(extraCondition.DataPowerOperationCode = dataPowerOperationCode);
	    isDataPowerEnable !== undefined &&
			(extraCondition.isDataPowerEnable = isDataPowerEnable);
	    isgrouppower !== undefined &&
			(extraCondition.isgrouppower = isgrouppower);
	    loadSelectedData && (extraCondition.loadSelectedData = true);
	    refcode && (extraCondition.refpath = refcode);

	    let finalExtraParam = {};
	    if (typeof extraParam === 'object') {
	        finalExtraParam = extraParam || {};
	    } else if (typeof extraParam === 'function') {
	        finalExtraParam = extraParam();
	    }

	    let final = {
	        ...param,
	        pid: pid === rootNode.refpk && !isTreelazyLoad ? "" : pid, // 对应的树节点
	        keyword,
	        // defineItems: this.getSearchConfigCodes(), // 搜索设置字段
	        queryCondition: { // 业务的过滤条件
	            ...(typeof queryCondition === 'function'
	                ? queryCondition(this.props)
	                : typeof queryCondition === 'object'
	                    ? queryCondition
	                    : {}),
	        },
	        pageInfo,
	        ...this.getParam(param || {}),
	        ...finalExtraParam,
	    };

	    if (keyword && Array.isArray(filterPks) && filterPks.length) {
	        final.filterPks = filterPks;
	    } else {
	        delete final.filterPks;
	    }

	    final.queryCondition = { ...extraCondition, ...final.queryCondition };

	    let refRelyConditionArray = refRelyCondition?.() ?? [];

	    let refRelyConditionObject = refRelyConditionArray.reduce((refRelyConditionObject, condition) => {
	        let { key, value, nofilter } = condition;
	        final.queryCondition[key] = value;
	        if (!nofilter) {
	            refRelyConditionObject[key] = value;
	        }
	        return refRelyConditionObject;
	    }, {});

	    final.refRelyCondition = refRelyConditionObject;

	    if (Array.isArray(searchPks) && searchPks.length) {
	        final.searchPks = searchPks;
	        final.pageInfo.pageSize = searchPks.length;
	    }

	    return final;
	};

	// 请求列表数据
	loadTableData = async (param, useCache = true, loading = true) => {
	    this.haveNoData = false;
	    const { queryGridUrl, refType } = this.props;
	    let { isUsualStatus } = this.getStatus();
	    if (refType === 'gridTree' && !param.pid) {
	        param.filterPids = await this.loadTreeData(
	            this.__getParam({ pageInfo: { pageIndex: -1 } }),
	            true,
	            loading,
	        ).then(data => {
	            return data.rows.map(e => e.refpk);
	        });
	    }
	    if (isUsualStatus) {
	        param.queryCondition.isShowUsual = true;
	        param.queryCondition.UsualActionURL = queryGridUrl;
	    }
	    param.defineItems = this.getSearchConfigCodes();
	    return this.sendAjax(queryGridUrl, param, useCache, loading).then(data => {
	        this.haveNoData = !data.rows.length;
	        return data;
	    });
	};

	// 请求树数据
	loadTreeData = async (param, useCache = true, loading = true) => {
	    const { queryTreeUrl, refType } = this.props;
	    if (refType === 'gridTree') {
	        delete param.refRelyCondition;
	    }
	    return this.sendAjax(queryTreeUrl, param, useCache, loading);
	};

	// 发送ajax请求
	sendAjax = (url, param, useCache, loading) => {
	    let {
	            isCacheable,
	            unitProps,
	            isShowUnit,
	            unitValueIsNeeded,
	            async,
	        } = this.props,
	        { unit } = this.state;

	    if (unitProps && isShowUnit && unitValueIsNeeded) {
	        let unitVal =
				Array.isArray(unit) && unit.length
				    ? unit.map(e => e.refpk).join(',')
				    : (unit || {}).refpk;
	        if (!unitVal) {
	            // 有业务单元，但是没有选值时，不发请求，清空数据
	            return Promise.resolve({
	                page: {
	                    pageSize: 10,
	                    pageIndex: 0,
	                },
	                rows: [],
	            });
	        }
	    }
	    let cacheData = this.hasCache(url, param);
	    if (useCache && isCacheable && cacheData) {
	        return Promise.resolve(cacheData);
	    } else {
	        return new Promise(resolve => {
	            this.setState(
	                { loading: loading && true },
	                () => {
	                    this.isFetching = true;
	                    ajax({
	                        async,
	                        url,
	                        data: param,
	                        loading: false,
	                        success: res => {
	                            this.isFetching = false;
	                            if (!res.success) {
	                                throw new Error(res.error.message);
	                            }
	                            isCacheable && this.setCacheData(url, param, res.data);
	                            resolve(res.data);
	                        },
	                        error: e => {
	                            this.isFetching = false;
	                            toast({
	                                color: e.type || 'danger',
	                                content: e.message,
	                            });
	                            this.setState({ loading: false });
	                            // throw new Error(e);
	                        },
	                    });
	                },
	            );
	        });
	    }
	};

	// 请求列表数据
	loadTableDataSync = (param, useCache = true, loading = true) => {
	    this.haveNoData = false;
	    const { queryGridUrl, refType, isShowUsual } = this.props;
	    let { activeKey } = this.state;
	    if (refType === 'gridTree' && !param.pid) {
	        param.filterPids = this.loadTreeDataSync(
	            this.__getParam({
	                pageInfo: {
	                    pageIndex: -1,
	                    pageSize: this.state.tableData[0].page.pageSize,
	                },
	            }),
	            useCache,
	            loading,
	        ).rows.map(e => e.refpk);
	    }
	    if (isShowUsual && activeKey === '1' && refType !== 'tree') {
	        param.queryCondition.isShowUsual = true;
	        param.queryCondition.UsualActionURL = queryGridUrl;
	    }
	    param.defineItems = this.getSearchConfigCodes();
	    let data = this.sendAjaxSync(queryGridUrl, param, useCache, loading);
	    this.haveNoData = !data.rows.length;
	    return data;
	};

	// 请求树数据
	loadTreeDataSync = (param, useCache = true, loading = true) => {
		const { queryTreeUrl, refType } = this.props;
        if (refType === 'gridTree') {
            delete param.refRelyCondition;
        }
	    return this.sendAjaxSync(queryTreeUrl, param, useCache, loading);
	};

	sendAjaxSync = (url, param, useCache) => {
	    let {
	            isCacheable,
	            unitProps,
	            isShowUnit,
	            unitValueIsNeeded,
	        } = this.props,
	        { unit } = this.state;

	    if (unitProps && isShowUnit && unitValueIsNeeded) {
	        let unitVal =
				Array.isArray(unit) && unit.length
				    ? unit.map(e => e.refpk).join(',')
				    : (unit || {}).refpk;
	        if (!unitVal) {
	            // 有业务单元，但是没有选值时，不发请求，清空数据
	            return {
	                page: {
	                    pageSize: 10,
	                    pageIndex: 0,
	                },
	                rows: [],
	            };
	        }
	    }
	    let cacheData = this.hasCache(url, param);
	    if (useCache && isCacheable && cacheData) {
	        return cacheData;
	    } else {
	        this.isFetching = true;
	        let data;
	        ajax({
	            async: false,
	            url,
	            data: param,
	            loading: false,
	            success: res => {
	                this.isFetching = false;
	                this.setState({ loading: false });
	                if (!res.success) {
	                    throw new Error(res.error.message);
	                }
	                isCacheable && this.setCacheData(url, param, res.data);
	                data = res.data;
	            },
	            error: e => {
	                this.isFetching = false;
	                toast({
	                    color: e.type || 'danger',
	                    content: e.message,
	                });
	                this.setState({ loading: false });
	                // throw new Error(e);
	            },
	        });
	        return data;
	    }
	};

	// 设置表格数据
	setTableData = (target, level, data) => {
	    let targetData = this.state[target];
	    targetData[level] = {
	        page: data.page,
	        rows: (targetData[level].rows || []).concat(data.rows),
	    };
	    if (data.page && data.page.pageIndex == 0) {
	        this.allpks = data.page.allpks || [];
	        this.totalPage = data.page.totalPage;
	    }
	    targetData[level].page &&
			(targetData[level].page.totalPage = this.totalPage || 0);
	    this.setState({ [target]: targetData }, () => {
	        this.refreshTip();
	    });
	};

	// 设置树数据
	setTreeData = (target, parentNode, data, cb) => {
	    let { idKey, pidKey, rootNode, refType } = this.props,
	        {
	            expandedKeys,
	            group,
	            treeDataWithChildren,
	            keyMap,
	            isTreeSearch,
	        } = this.state;

	    if (refType === 'tree') {
	        this.setState({ loading: false });
	    }
		
	    // 把父节点下的节点清空
	    if (parentNode[idKey]) {
	        // 防止修改originGroup的引用
	        group = { ...group };
	        (function test(pid) {
	            if (group[pid]) {
	                group[pid].map(node => {
	                    test(node[idKey]);
	                });
	                group[pid] = [];
	            }
	        })(parentNode[idKey]);
	    }

	    // 重置根节点
	    group['undefined'] = rootNode;

	    let treeData = this.groupToArray(group),
	        dataMap = {};
	    treeData = treeData.concat(data.rows);

	    data.rows.forEach(e => {
	        // 每一个节点存有一个key属性，用来表示该节点的全路径;pKey表示父节点的全路径
	        e._display = this.props.treeConfig.code
	            .map(field => this.getDisplayOrValue(e, field))
	            .join(' ');
	        e[pidKey] = e[pidKey] || parentNode[idKey];
	        dataMap[e[idKey]] = e;
	    });

	    // 处理expandedKeys
	    if (this._expandedKeys && !isTreeSearch) {
	        // 恢复到搜索之前的状态
	        expandedKeys = this._expandedKeys;
	        delete this._expandedKeys;
	    } else if (isTreeSearch) {
	        // 搜索时展开全部
	        expandedKeys = treeData.map(e => e[idKey]);
	    } else {
	        // 新加进来的节点，展开都设为false
	        // fix: 再打开时保留上次的展开状态，所以注释到下面那行
	        // expandedKeys = expandedKeys.filter(e => !dataMap[e]).concat([parentNode[idKey]]);
	    }

	    // 处理数据格式
	    ({ group, treeDataWithChildren, treeData, keyMap } = this.arrayToGroup(
	        treeData,
	    ));
	    if (!isTreeSearch) {
	        this.originGroup = group;
	        this.originKeyMap = keyMap;
	    }
	    this.setState(
	        {
	            [target]: treeData,
	            expandedKeys,
	            group,
	            treeDataWithChildren,
	            keyMap,
	        },
	        () => {
	            this.run(cb, data);
	            refType === 'tree' && this.refreshTip();
	        },
	    );
	};

	// 分组数据 => 树数组数据
	groupToArray = group => {
	    let arr = [];
	    Object.keys(group).forEach(key => {
	        arr = arr.concat(group[key]);
	    });
	    return arr;
	};

	// 树数组数据 => 分组数据
	arrayToGroup = treeData => {
	    const { idKey, pidKey, rootNode } = this.props;
	    let group = {},
	        keyMap = {},
	        rootNodePk = rootNode[idKey];
	    treeData.forEach(e => {
	        let { children, ...others } = e;
	        keyMap[e[idKey]] = e;

	        group[e[pidKey]]
	            ? group[e[pidKey]].push(others)
	            : (group[e[pidKey]] = [others]);
	    });

	    // 如果没有可以挂载的节点，就挂到根节点上
	    Object.keys(group).forEach(pid => {
	        if (pid !== 'undefined' && pid !== rootNodePk && !keyMap[pid]) {
	            group[rootNodePk]
	                ? group[rootNodePk].push(...group[pid])
	                : (group[rootNodePk] = [...group[pid]]);
	            delete group[pid];
	        }
	    });

	    // 构造树结构
	    let treeDataWithChildren = this.groupToTree(group, group['undefined']);
	    // 转回数组结构，其中包含了disabled属性和level属性
	    treeData = this.treeToArray(treeDataWithChildren);
	    return {
	        group,
	        treeDataWithChildren,
	        treeData,
	        keyMap,
	    };
	};

	// 分组数据 => 树数组数据
	groupToTree = (group, data, level = 0, index = { value: 0 }) => {
	    let { idKey, rootNode } = this.props;
	    let { isTreeSearch } = this.state;
	    if (!data) {
	        return null;
	    }
	    return data.map(e => {
	        let disabled = rootNode[idKey] !== e[idKey] && this.isDisabled(e);
	        e.disabled = disabled;
	        e.index = ++index.value;
	        e.level = level;
	        e.key = e[idKey];
	        let children = this.groupToTree(
	            group,
	            group[e[idKey]],
	            level + 1,
	            index,
	        );
			
	        if (Array.isArray(children)) {
	            e.children = children;
	        }
	        if (!e.hasOwnProperty('isleaf')) {
	            e.isleaf = !(Array.isArray(children) && children.length);
	        }
	        return e;
	    });
	};

	// 树形数据 => 树数组数据
	treeToArray = (tree, arr = []) => {
	    if (Array.isArray(tree)) {
	        tree.forEach(e => {
	            let { children, ...others } = e;
	            arr.push({ ...others });
	            if (Array.isArray(e.children)) {
	                this.treeToArray(e.children, arr);
	            }
	        });
	    }

	    return arr;
	};

	// 获取一个值的某个（些）field值
	getOneDisplayOrValue = (item, field, sep) => {
	    return Array.isArray(field)
	        ? field
	            .map(
	                e =>
	                    item[e] ||
							(item.values &&
								item.values[e] &&
								(item.values[e].display || item.values[e].value)) ||
							'',
	            )
	            .join(sep)
	        : item[field] ||
					(item.values &&
						item.values[field] &&
						(item.values[field].display || item.values[field].value)) ||
					'';
	};

	// 获取多个值的某个field值
	getDisplayOrValue = (items, field, props) => {
	    let { fieldDisplayed, fieldValued, fieldSplitSep, fieldJoinSep } =
			props || this.props;
	    if (field === 'display') {
	        if (fieldDisplayed.includes(fieldSplitSep)) {
	            field = fieldDisplayed.split(fieldSplitSep);
	        } else {
	            field = fieldDisplayed;
	        }
	    } else if (field === 'value') {
	        field = fieldValued;
	    }
	    return items
	        ? Array.isArray(items)
	            ? items
	                .map(e => this.getOneDisplayOrValue(e, field, fieldJoinSep))
	                .join(',')
	            : this.getOneDisplayOrValue(items, field, fieldJoinSep)
	        : '';
	};

	// 获取参照的实际值
	getTrueValue = props => {
	    let { foolValue, value } = props || this.props;
	    return foolValue
	        ? this.foolValueToValue(foolValue, props || this.props)
	        : value;
	};

	// 判断前后两次选中的值是否一样
	isEqual = (newValue, oldValue) => {
	    let {
	            isMultiSelectedEnabled,
	            refType,
	            onlyLeafCanSelect,
	            isRunWithChildren,
	            isAlwaysEmitOnChange,
	        } = this.props,
	        isEqual;

	    if (isMultiSelectedEnabled) {
	        isEqual = compareArr(newValue, oldValue);
	    } else {
	        isEqual = (newValue || {}).refpk === (oldValue || {}).refpk;
	    }

	    if (
	        isMultiSelectedEnabled &&
			refType === 'tree' &&
			!onlyLeafCanSelect &&
			isRunWithChildren &&
			this.runWithChildren !== !!this.state.runWithChildren
	    ) {
	        // 当有【执行时包含下级】且两次勾选情况不一样时，触发编辑后
	        isEqual = false;
	    }

	    if (isAlwaysEmitOnChange) {
	        isEqual = false;
	    }

	    return isEqual;
	};

	// 单选的方法
	singleSelect = async (item, del, clear) => {
	    // 添加clear 參數 用於控制 清空时展开历史记录 by bbqin
	    // 单选
	    let { 
	            onChange, 
	            extraOnChange, 
	            isMultiSelectedEnabled, 
	            type, 
	            needQuerySelectedDataBeforeOnChange,
	        } = this.props,
	        value = this.getTrueValue(),
	        { selectedValues, referVal, isShow } = this.state,
	        { isSearchStatus, isSelectedStatus } = this.getStatus();
	    item = item || [...selectedValues.values()][0];

	    if (!isMultiSelectedEnabled && del === true) {
	        item = {};
	    }

	    if (type === 'dropDown' && isShow) {
	        this.focusFlag = false;
	        this.referInput && this.referInput.blur();
	        this.setState({ isShow: false });
	    }
		
	    // 多选时的【搜索】和【已选】不失焦不收起，其余都失焦且收起
	    // 搜索下拉的所有项被选中时，收起
	    if (!(isMultiSelectedEnabled && (isSearchStatus || isSelectedStatus))) {
			 this.setState(
				 {
					 dropDownShow: false,
					 isSelectedShow: false,
				 },
				 () => {
	                //  // UE说选中下拉之后要聚焦  by bbqin
	                //  if (this.hotKeyClose || this.clearFlag || this.focusFlag) {
	                // 	 this.referInput && this.referInput.focus();
	                // 	 this.focusFlag = true;
	                //  } else {
	                // 	 this.focusFlag = false;
	                // 	 this.referInput && this.referInput.blur();
	                //  }
				 },
			 );
		 }

	    // 判断前后两次选中的值是否一样，一样的话则不做任何处理
	    let isEqual = this.isEqual(isMultiSelectedEnabled ? [item] : item, value);

	    // 如果选中的是fx函数
	    if (item && /^#.*#$/.test(item.refpk)) {
	        selectedValues = new Map();
	    }

	    if (item && item.refpk) {
	        if (isMultiSelectedEnabled) {
	            // 存入已选择
	            this.toggleValueForMapOrObject(selectedValues, item.refpk, item);
	            referVal = this.getDisplayOrValue([...selectedValues.values()], 'display');

	            // 保证onChange的执行顺序
	            this.state.referVal = referVal;
	            this.state.selectedValues = selectedValues;

	            let selections = this.getSelections();
	            if (needQuerySelectedDataBeforeOnChange) {
	                selections = await this.loadSelectedData(selections);
	            }
	            let foolDisplay = this.getDisplayOrValue(selections, 'display'),
	                foolValue = this.getDisplayOrValue(selections, 'value');
				
	            let emitOnChange = !isEqual && !((isSearchStatus || isSelectedStatus) && isMultiSelectedEnabled); 
	            emitOnChange && (this._value = new Map(JSON.parse(JSON.stringify(selectedValues))));

	            this.run(
	                [
	                    emitOnChange && onChange,
	                    emitOnChange && extraOnChange,
	                ],
	                selections,
	                {
	                    display: foolDisplay,
	                    value: foolValue,
	                },
	            );
	            if (del === true && !selections.length) {
	                this.focusFlag = false;
	                this.referInput && this.referInput.blur();
	                this.setState({
	                    isSelectedShow: clear === true,
	                    dropDownShow: false,
	                });
	            }
	            this.setState({ selectedValues, referVal });
	        } else {
	            // 存入已选择
	            selectedValues = new Map(
	                Object.entries({ [item.refpk]: item }),
	            );
				
	            let foolDisplay = this.getDisplayOrValue(item, 'display'),
	                foolValue = this.getDisplayOrValue(item, 'value');
	            referVal = foolDisplay;
				
	            this.state.selectedValues = selectedValues;
	            this.state.referVal = referVal;

	            !isEqual && (this._value = new Map(JSON.parse(JSON.stringify(selectedValues))));
	            this.run([!isEqual && onChange, !isEqual && extraOnChange], item, {
	                display: foolDisplay,
	                value: foolValue,
	            });

	            this.setState({ selectedValues, referVal });
	        }
	        // 存入历史记录localStorage
	        this.pushToLocal(item);
	    } else {
	        selectedValues = new Map();

	        this.state.selectedValues = selectedValues;

	        !isEqual && (this._value = new Map(JSON.parse(JSON.stringify(selectedValues))));
	        this.run(
	            [!isEqual && onChange, !isEqual && extraOnChange],
	            {},
	            { display: '', value: '' },
	        );

	        this.setState({ selectedValues, referVal: '' });
	    }

	    this.setState(
	        { isMoreButtonShow: false },
	        () => {
	            if (this.clearFlag) {
	                this.clearFlag = false;
	            }
	        },
	    );
	};

	// 多选的方法
	multiSelect = async () => {
	    let selections = this.getSelections(),
	        { onChange, extraOnChange, maxChoice, needQuerySelectedDataBeforeOnChange } = this.props;

	    if (selections.length > maxChoice) {
	        // 最多选择***条数据
	        toast({
	            color: 'warning',
	            // eslint-disable-next-line no-template-curly-in-string
	            content: `${(this.state.jsonInsideRefer['containers-refer-0000'] || '')
	            // eslint-disable-next-line no-template-curly-in-string
	                .replace('${0000}', maxChoice)}`,
	        });
	        return;
	    }

	    let isEqual = this.isEqual(
	        selections.map(e => e.refpk),
	        [...this._value.keys()],
	    );

	    isEqual || this.pushToLocal([...selections]);

	    let index =
			selections.length > 1
			    ? selections.findIndex(e => /^#.*#$/.test(e.refpk))
			    : -1;

	    if (index !== -1) {
	        selections.splice(index, 1);
	    }

	    if (needQuerySelectedDataBeforeOnChange) {
	        selections = await this.loadSelectedData(selections);
	    }
		
	    // 从setState回调中移出来，解决表格中失焦触发onChange
	    let foolDisplay = this.getDisplayOrValue(selections, 'display'),
	        foolValue = this.getDisplayOrValue(selections, 'value');
		
	    !isEqual && (this._value = new Map(JSON.parse(JSON.stringify(this.state.selectedValues))));
	    this.run([!isEqual && onChange, !isEqual && extraOnChange], selections, {
	        display: foolDisplay,
	        value: foolValue,
	    });

	    this.setState(
	        {
	            referVal: foolDisplay,
	            isMoreButtonShow: false,
	        },
	        () => {
	            // 多选清空之后获取焦点，触发历史记录
	            if (this.clearFlag) {
	                // 先失去焦点再获取焦点，保证能触发onFocus
	                this.referInput && this.referInput.blur();
	                this.referInput && this.referInput.focus();
	                this.clearFlag = false;
	            }
	        },
	    );
	};

	// 获取已选择的数据
	getSelections = (options = {}) => {
	    let { cleanIsLeaf = false } = options;
	    const { rootNode, queryTreeUrl, isRunWithChildren } = this.props;
	    let { runWithChildren, selectedValues } = this.state;
	    const selections = [...selectedValues.values()]
	        .filter(e => e.refpk !== rootNode.refpk)
	        .map(e => {
	            let { children, ...others } = e,
	                final = { ...others };
	            if (cleanIsLeaf) {
	                let { isleaf, ..._others } = others;
	                final = { ..._others };
	            }

	            if (isRunWithChildren && runWithChildren) {
	                final.runWithChildren = runWithChildren;
	                final.queryTreeUrl = queryTreeUrl;
	            } else {
	                delete final.runWithChildren;
	                delete final.queryTreeUrl;
	            }

	            return final;
	        });
	    return this.filterDisabledData(selections);
	};

	treeFilter = (rows, keyword, findParentNode = true) => {
	    let rowMap = new Map(),
	        { idKey, rootNode } = this.props,
	        rootId = rootNode[idKey];
	    // 先筛选出来，不区分大小写
	    let codes = ['refname', 'refcode'];
	    // let codes = treeConfig.code;
	    keyword = keyword.toLowerCase();
	    rows = rows.filter(row =>{
	        for (let field of codes) {
	            let fieldValue = this.getDisplayOrValue(row, field).toLowerCase();
	            let res = fieldValue.indexOf(keyword);
	            if (res > -1) {
	                row.indexOf = res;
	                row.keylength = fieldValue.length;
	                return true;
	            }
	        }
	        return false;
	    });

	    // rows = rows.sort((a, b) => a.keylength - b.keylength).sort((a, b) => a.indexOf - b.indexOf);
	    // 反查父节点
	    rows.forEach(node => {
	        let parentNode = this.findParent(node);
	        !rowMap.has(node[idKey]) && rowMap.set(node[idKey], node);
	        if (findParentNode) {
	            while (parentNode) {
	                if (!rowMap.has(parentNode[idKey])) {
	                    rowMap.set(parentNode[idKey], parentNode);
	                    parentNode = this.findParent(parentNode);
	                } else {
	                    break;
	                }
	            }
	        }
	    });
	    // 除去根节点
	    rowMap.delete(rootId);
	    return [...rowMap.values()];
	};

	findParent = node => {
	    let keyMap = this.originKeyMap,
	        { pidKey } = this.props;
	    return keyMap[node[pidKey]];
	};

	// 搜索的请求
	dropDownSearch = () => {
	    let that = this,
	        { refType, searchDataSize, rootNode } = this.props,
	        { referVal, searchHasMoreData } = this.state,
	        param;
		
	    if (refType === 'tree') {
	        let data = this.loadTreeDataSync(this.__getParam({ pageInfo: { pageIndex: -1 } }));
	        this.setTreeData('treeData', rootNode, data);
	    }
	    // 后台不支持同时中英文逗号
	    let keywords = referVal.split(/,|，/);
	    let keyword = keywords.join(',');
	    param = this.__getParam({ keyword });

	    // 加一条来判断是否还有更多数据
	    // if (refType !== 'tree') {
	    param.pageInfo = {
			    pageSize: keywords.length > 1 ? keywords.length : Number(searchDataSize) + 1,
			    pageIndex: 0,
	    };
	    // }
	    (refType === 'tree' ? this.loadTreeData : this.loadTableData)(param, true, false).then(
	        data => {
	            if (referVal === this.state.referVal) {
	                // 查询发起时的keyword和查询结束时的keyword相同时才渲染
	                // 树型参照走前端筛选（没必要前端筛选）
	                // 懒加载的树走后台
	                // refType === 'tree' &&
	                // 	!isTreelazyLoad &&
	                // 	(data.rows = this.treeFilter(data.rows, referVal, false));
	                let { dropDownList } = that.state;
	                dropDownList.rows = data.rows;
	                if (data.rows[searchDataSize]) {
	                    searchHasMoreData = true;
	                }
	                that.setState({
	                    dropDownList,
	                    searchHasMoreData,
	                    loading: false,
	                });
	            }
	        },
	    );
	};

	// 获取搜索设置为true的字段
	getSearchConfigCodes = (flag = false) => {
	    let columnConfig =
				typeof this.getColumnConfig === 'function'
				    ? this.getColumnConfig()[0]
				    : {},
	        search = columnConfig.search || {},
	        codes = [...new Set(Object.keys(search).filter(code => search[code]))];
	    flag && codes.push('refname', 'refcode');
	    return codes;
	};

	handleBlurEvent = () => {
	    if (this.hotKeyClose) {
	        // this.hotKeyClose = false;
	        return;
	    }
	    if (this.clearFlag) {
	        // this.clearFlag = false;
	        return;
	    }
	    let { isMultiSelectedEnabled, onBlur } = this.props;
	    let selections = this.getSelections();
	    !isMultiSelectedEnabled && (selections = selections[0] || {});
	    let foolDisplay = this.getDisplayOrValue(selections, 'display'),
	        foolValue = this.getDisplayOrValue(selections, 'value');
	    this.run([onBlur], selections, {
	        display: foolDisplay,
	        value: foolValue,
	    });
	};

	showCodeIfPossible = value => {
	    let { showCodeWhenFocus, fieldValued } = this.props;
	    return showCodeWhenFocus && fieldValued === 'refpk' && this.getDisplayOrValue(value, 'refcode') || this.getDisplayOrValue(value, 'display');
	}

	// 失去焦点的事件
	blur = () => {
	    this.focusFlag = false;
		
	    let { selectedValues, referVal, dropDownList } = this.state,
	        {
	            isMultiSelectedEnabled,
	            checkStrictly,
	            fieldDisplayed,
	            fieldValued,
	            fieldSplitSep,
	            isBlurSearch,
	            refType,
	        } = this.props,
	        {
	            isHistoryStatus,
	            isSelectedStatus,
	            isShowStatus,
	        } = this.getStatus();
	    if (isShowStatus) {
	        return false;
	    }
	    if (isHistoryStatus) {
	        // 历史记录
	        selectedValues.clear();
	        isMultiSelectedEnabled ? this.multiSelect() : this.singleSelect({});
	    } else if (isSelectedStatus) {
	        isMultiSelectedEnabled ? this.multiSelect() : this.singleSelect();
	    } else {
	        // isSearchStatus
	        let codes = this.getSearchConfigCodes(true);
	        if (
	            codes.some(field => referVal === this.getDisplayOrValue([...selectedValues.values()], field)) || 
				this.showCodeIfPossible([...selectedValues.values()]) === referVal
	        ) {
	            isMultiSelectedEnabled ? this.multiSelect() : this.singleSelect();
	        } else {
	            if (isBlurSearch) {
					let searchCount = 50;
					if (isMultiSelectedEnabled && /,|，/.test(referVal)) {
						let keywords = [...new Set(referVal.split(/,|，/))];
						searchCount += keywords.length;
					}
	                let param = this.__getParam({ 
	                    keyword: referVal.replace(fieldSplitSep, ','), 
	                    // 后端数据无法根据关键字排序，导致完全匹配的可能在分页外，故调大pageSize，解决大部分场景
	                    pageInfo: { pageSize: searchCount, pageIndex: 0 }, 
	                });
							
	                let data = (refType === 'tree' ? this.loadTreeDataSync : this.loadTableDataSync)(param);
	
	                if (referVal === this.state.referVal) {
	                    dropDownList.rows = data.rows;
	                }
	            }
	            // 搜索状态
	            // 是否与搜索结果某一项完全匹配
	            selectedValues.clear();
	            let rowsOfDropDownList = this.filterDisabledData(dropDownList.rows) || [];
	            if (isMultiSelectedEnabled && /,|，/.test(referVal)) {
	                // 含逗号多个搜索
	                let keywords = [...new Set(referVal.split(/,|，/))];
	                keywords.map(keyword => {
	                    let matchedRow = rowsOfDropDownList.find(row => codes.some(field => keyword === this.getDisplayOrValue(row, field)));
	                    if (matchedRow) {
	                        selectedValues.set(matchedRow.refpk, matchedRow);
	                    } else if (!checkStrictly) {
	                        // 非严格检查
	                        selectedValues.set(keyword, {
	                            refname: keyword,
	                            refcode: keyword,
	                            refpk: keyword,
	                            [fieldDisplayed]: keyword,
	                            [fieldValued]: keyword,
	                        });
	                    }
	                });
	                this.multiSelect();
	            } else {
	                // 不含逗号单个搜索
					let newVal = referVal;
					if(referVal?.includes(fieldSplitSep)){
						newVal = referVal.split(fieldSplitSep)[0];
					}
					let results = Array.isArray(rowsOfDropDownList) ? rowsOfDropDownList.filter(row => codes.some(field => this.getDisplayOrValue(row, field).includes(newVal))) : [];
	                let item;
					if (checkStrictly) {
						item = results.length === 1 ? results[0] : results.length > 1 ? results.find(row => codes.some(field => this.getDisplayOrValue(row, field) === newVal)) : null;
					} else {
						item = results.find(row => codes.some(field => this.getDisplayOrValue(row, field) === newVal));
					}
	                if (item) {
	                    // 完全匹配
	                    isMultiSelectedEnabled
	                        ? (selectedValues.set(item.refpk, item), this.multiSelect())
	                        : this.singleSelect(item);
	                } else if (checkStrictly) {
	                    // 严格检查
	                    selectedValues.clear();
	                    isMultiSelectedEnabled
	                        ? this.multiSelect()
	                        : this.singleSelect({});
	                } else {
	                    // 非严格检查
	                    let item = {};
			
	                    if (fieldDisplayed.includes(fieldSplitSep)) {
	                        fieldDisplayed.split(fieldSplitSep);
	                    }
	                    Array.isArray(fieldDisplayed)
	                        ? fieldDisplayed.forEach(e => {
	                            item[e] = referVal;
							  })
	                        : (item[fieldDisplayed] = referVal);
			
	                    Array.isArray(fieldValued)
	                        ? fieldValued.forEach(e => {
	                            item[e] = referVal;
							  })
	                        : (item[fieldValued] = referVal);
			
	                    isMultiSelectedEnabled
	                        ? (!selectedValues.size && selectedValues.set(item.refpk, item),
							  this.multiSelect())
	                        : this.singleSelect(item);
	                }
	            }
	        }
	    }
				
	    this.handleBlurEvent();
	    this.setState({
	        isShow: isShowStatus,
	        dropDownShow: false,
	        isSelectedShow: false,
	        multiSearch: false,
	        loading: false,
	    });
	};

	// 获取参照当前的打开状态
	getStatus = () => {
	    let isHistoryStatus,
	        isSearchStatus,
	        isSelectedStatus,
	        isShowStatus,
	        isFocusStatus,
	        isUsualStatus,
	        isEdit,
	        { dropDownShow, isSelectedShow, referVal, isShow, activeKey } = this.state;
	    let { showHistory, renderInTable, isShowSelected, refType, isShowUsual } = this.props;
	    isHistoryStatus = !!(dropDownShow && !referVal);
	    if (renderInTable) {
	        isHistoryStatus = showHistory && isHistoryStatus && this.state.historySelectionVisible;
	    } else {
	        isHistoryStatus = showHistory && isHistoryStatus;
	    }
	    isSearchStatus = !!(dropDownShow && referVal) && !this.focusFromPopoverBlur;
	    isSelectedStatus = isShowSelected && !isHistoryStatus && !isSearchStatus && isSelectedShow;
	    isShowStatus =
			isShow && this.popWindow && this.popWindow === this.getTopWindow();
	    // 传入clickContainer时不获取焦点
	    isFocusStatus = this.focusFlag && !isShow && !this.props.clickContainer;
	    isEdit = isHistoryStatus || isSearchStatus || isSelectedStatus;
	    isUsualStatus = isShowStatus && isShowUsual && activeKey === '1' && refType !== 'tree';

	    return {
	        isHistoryStatus,
	        isSearchStatus,
	        isSelectedStatus,
	        isShowStatus,
	        isFocusStatus,
	        isEdit,
	        isUsualStatus,
	    };
	};

	// 兼容旧版的数据结构
	updateHistory = history => {
	    return history
	        .map(e => (e && typeof e === 'object' ? e.refpk : e))
	        .filter(e => e);
	};

	// 存入localStorage
	pushToLocal = (item, key = 'referHistory') => {
	    // 一个或多个
	    let isArray = Array.isArray(item),
	        { hotDataSize, queryGridUrl, queryTreeUrl } = this.props,
	        historyKey = queryGridUrl + queryTreeUrl,
	        ReferHistory = this.getStorage(key),
	        history = ReferHistory[historyKey] || [];
	    history = this.updateHistory(history);
	    // 去除重复的
	    for (let i = history.length - 1; i >= 0; i--) {
	        let flag = isArray
	            ? item.find(e => history[i] === e.refpk)
	            : history[i] === item.refpk;
	        flag && history.splice(i, 1);
	    }
	    // 添加新的

	    isArray
	        ? history.unshift(...item.map(e => e.refpk).reverse())
	        : history.unshift(item.refpk);
	    if (history.length > hotDataSize) {
	        history = history.slice(0, hotDataSize);
	    }
	    ReferHistory[historyKey] = [...new Set(history)];
	    this.setStorage(key, JSON.stringify(ReferHistory));
	};

	// 格式转化：localStorage => list
	localToList = (key = 'referHistory') => {
	    let { queryGridUrl, queryTreeUrl } = this.props,
	        historyKey = queryGridUrl + queryTreeUrl,
	        history =
				JSON.parse(getGlobalStorage('localStorage', key) || '{}')[historyKey] ||
				[];

	    return this.updateHistory(history);
	};

	handleInputClick = () => {
	    let {
	            disabled,
	            showHistory,
	            isMultiSelectedEnabled,
	        } = this.props,
	        { isShow, referVal } = this.state;
	    if (isShow || disabled) {
	        // isShow兼容DropDownRefer
	        return false;
	    }

	    let trueValue = [...(this._value || new Map()).values()];

	    if (trueValue.length) {
	        if (isMultiSelectedEnabled) {
	            this.handleSelected();
	        }
	    } else if (showHistory && !referVal) {
	        this.handleHistory();
	    }
	}

	// 输入框焦点事件
	handleFocus = () => {
	    if (
	        !(this.referInput && this.referInput.contains(document.activeElement))
	    ) {
	        // 触发这个事件的时候，焦点已不再当前input中了，就不继续执行了
	        return;
	    }
	    this.focusFlag = true;
	    // return也可以触发更新然后获取焦点边框
	    this.forceUpdate();
	    let { disabled } = this.props,
	        { isShow } = this.state;
	    if (isShow || disabled) {
	        // isShow兼容DropDownRefer
	        return false;
	    }
	    if (this.hotKeyClose) {
	        // 快捷键关闭时，获取焦点，但是不触发事件
	        this.hotKeyClose = false;
	        return;
	    }

	    this.autoFocus = false;
	    this.focusFromPopoverBlur = false;
	}

	// 输入框输入事件
	handleInput = (referVal, { searchNow = true } = {}) => {
	    // 只要触发输入就清空已选值，之后失焦的时候再触发选中逻辑
	    this.setState({ referVal, selectedValues: new Map() }, () => {
	        if (this.state.referVal && searchNow) {
	            this.handleSearch();
	        } else if (!this.state.referVal && this.props.showHistory) {
	            this.handleHistory();
	        }
	    });
	};

	handleHistory = () => {
	    let {
	            queryGridUrl,
	            refType,
	            hotDataSize,
	        } = this.props,
	        { dropDownList, referVal } = this.state;
	    // 没值历史记录
	    let history = this.localToList('referHistory');
	    if (history.length) {
	        let param = this.__getParam({
	            pageInfo: { pageSize: hotDataSize },
	            searchPks: history,
	            isHistory: true,
	        });
	        if (refType === 'tree') {
	            this.loadTreeData(param, true, false).then(data => {
	                if (!referVal) {
	                    data.rows = this.sortRowsByPk(data.rows, history, true);
	                    this.setState({
	                        loading: false,
	                        dropDownList: data,
	                    });
	                }
	            });
	        } else if (queryGridUrl) {
	            this.loadTableData(param, true, false).then(data => {
	                if (!referVal) {
	                    data.rows = this.sortRowsByPk(data.rows, history, true);
	                    this.setState({
	                        loading: false,
	                        dropDownList: data,
	                    });
	                }
	            });
	        }
	    } else {
	        dropDownList.rows = [];
	        this.setState({
	            loading: false,
	            dropDownList,
	        });
	    }
	    this.setState({
	        dropDownShow: true,
	        isSelectedShow: false,
	    });
	}

	handleSearch = () => {
	    let { inputDefer, isMultiSelectedEnabled } = this.props,
	        { dropDownList, referVal } = this.state;
	    dropDownList.rows = [];
	    this.interval = new Date().getTime();
	    let s = setTimeout(() => {
	        // 停止输入0.5s后执行
	        if (new Date().getTime() - this.interval >= inputDefer) {
	            if (this.state.referVal) {
	                this.state.dropDownList.rows = [];
	                this.dropDownSearch();
	            }
	        }
	        clearTimeout(s);
	    }, inputDefer);
	    this.setState({
	        dropDownShow: true,
	        isSelectedShow: false,
	        multiSearch: isMultiSelectedEnabled && /,|，/.test(referVal),
	    });
	}

	handleSelected = () => {
	    this.setState({
	        dropDownShow: false,
	        isSelectedShow: true,
	    });
	}

	// 点击参照以外的区域收起下拉
	close = () => {
	    // 失去焦点校验
	    this.blur();
	    
	    if (this.state.isMoreButtonShow) {
	        this.setState({ isMoreButtonShow: false });
	    }
	};

	// 用快捷键关闭参照时触发的事件
	onHotKeyClose = () => {
	    // this.props.onEnter 存在 就不设置 hotKeyClose关闭了
	    this.hotKeyClose = !this.props.onEnter;
	    this.focusFlag = true;
	    let timer = setTimeout(() => {
	        this.referInput && this.referInput.focus();
	        clearTimeout(timer);
	    }, 10);
	    this.setState({
	        dropDownShow: false,
	        loading: false,
	        isAddButtonShow: false,
	    });
	    // this.handlePopoverBlur();
	};

	// 在参照输入框中删除
	clear = () => {
	    this.clearFlag = true;
	    const { isMultiSelectedEnabled, disabled } = this.props;
	    if (disabled) {
	        return false;
	    }
	    // this.state.selectedValues = new Map();
	    this.setState({
	        selectedValues: new Map(),
	        dropDownShow: true,
	        isShow: false,
	        isSelectedShow: false,
	        referVal: '',
	    }, () => {
	        isMultiSelectedEnabled
	            ? this.multiSelect()
	            : this.singleSelect({}, undefined, true);
				this.referInput?.focus();
	        this.handleInput('');
	    });
	};

	// 删除一个值
	delItem = item => {
	    let { selectedValues } = this.state;
	    selectedValues.delete(item.refpk);
	    this.setState({ selectedValues });
	};

	// 选择函数时的点击事件
	onFunctionClick = item => {
	    const {
	        isMultiSelectedEnabled,
	        fieldDisplayed,
	        fieldValued,
	        fieldSplitSep,
	        refType,
	    } = this.props;

	    let value = {
	        refname: item.name,
	        refpk: item.code,
	    };

	    if (item.hasOwnProperty('value')) {
	        let param = this.__getParam({
	            pageInfo: { pageSize: 1 },
	            searchPks: [item.value],
	        });

	        // 校验函数是否合法
	        value.isValid = !!(refType === 'tree' ? this.loadTreeDataSync : this.loadTableDataSync)(param)?.rows?.length;
	    }
	
	    if (fieldDisplayed.includes(fieldSplitSep)) {
	        fieldDisplayed.split(fieldSplitSep);
	    }
	
	    Array.isArray(fieldDisplayed)
	        ? fieldDisplayed.forEach(e => {
	            value[e] = item.name;
	        })
	        : (value[fieldDisplayed] = item.name);
	
	    Array.isArray(fieldValued)
	        ? fieldValued.forEach(e => {
	            value[e] = item.code;
	        })
	        : (value[fieldValued] = item.code);
	    if (isMultiSelectedEnabled) {
	        this.setState(
	            { selectedValues: new Map([[item.code, value]]) },
	            function () {
	                this.multiSelect();
	            },
	        );
	    } else {
	        this.singleSelect(value);
	    }

	};

	// 编辑前事件
	beforeEvent = (
	    onFocus,
	    callback,
	    event,
	    { fromFocus, fromIconRefer } = {},
	) => {
	    // event && typeof event.stopPropagation === 'function' && event.stopPropagation();
	    let { isMultiSelectedEnabled, onEnter } = this.props,
	        { referVal } = this.state;
	    if (typeof onFocus === 'function') {
	        let res = onFocus(
	            isMultiSelectedEnabled
	                ? this.getSelections()
	                : this.getSelections()[0] || {},
	            event,
	        );
	        if (res instanceof Promise) {
	            res.then(isContinue => {
	                // 容错undefined
	                if (isContinue !== false) {
	                    // Promise异步，导致调用 beforeEvent 和 callback 时的 referVal 可能不一致
	                    referVal = this.state.referVal;
	                    fromFocus ? this.run(callback, referVal) : this.run(callback);
	                } else {
	                    this.referInput && this.referInput.blur();
	                    //鼠标点击时不触发onEnter查找下一个焦点的方法
	                    this.referInputMouseDown !== true &&
							fromIconRefer !== true &&
							onEnter &&
							onEnter({ e: event });
	                }
	            });
	        } else if (res !== false) {
	            // 容错undefined
	            referVal = this.state.referVal;
	            fromFocus ? this.run(callback, referVal) : this.run(callback);
	        } else {
	            this.referInput && this.referInput.blur();

	            this.referInputMouseDown !== true &&
					fromIconRefer !== true &&
					onEnter &&
					onEnter({ e: event });
	        }
	    } else {
	        referVal = this.state.referVal;
	        fromFocus ? this.run(callback, referVal) : this.run(callback);
	    }
	};

	// 加载已选数据
	loadSelectedData = (selections, { shouldUpdate = true } = {}) => {
	    selections = selections || this.getSelections();
	    if (selections.length) {
	        const { refType, idKey, checkStrictly } = this.props;
	        let param = this.__getParam({
	            searchPks: selections.map(e => e['refpk'] || e[idKey]),
	            pageInfo: { pageIndex: 0 },
	            loadSelectedData: true,
	        });
	        let data = (refType === 'tree' ? this.loadTreeDataSync : this.loadTableDataSync)(
	            param,
	        );

	        data.rows = this.sortRowsByPk(
	            [...selections, ...data.rows],
	            selections.map(e => e['refpk'] || e[idKey]),
	            checkStrictly,
	        );
	        if (shouldUpdate) {
	            let selectedValues = new Map(data.rows.map(e => [e[idKey], e]));
	            this.setState({ selectedValues, loading: false });
	        }
	        return data.rows;
	    }
	};

	// 绑定快捷键
	bindHotKeys = ({ trueValue }) => {
	    let { onFocus, isMultiSelectedEnabled } = this.props,
	        { isFocusStatus } = this.getStatus();

	    return (
	        <HotKeys
	            keyMap={{
	                f2: 'f2',
	                del: ['del', 'backspace'],
	                // tab: [
	                // 	'tab',
	                // 	'shift+tab'
	                // ],
	                esc: 'esc',
	                showHistorySelection: 'ctrl',
	            }}
	            handlers={{
	                f2: () => {
	                    if (isFocusStatus) {
	                        this.show();
	                    }
	                },
	                del: event => {
	                    // let { isFocusStatus, isEdit } = this.getStatus();
	                    // //参照输入框点击删除按钮判断当前是选中后状态还是输入状态,如果是输入状态，按删除就一个个删，如果是选中后状态就直接全部删除
	                    // if (
	                    //     isFocusStatus &&
	                    // 	trueValue.length > 0 &&
	                    // 	isMultiSelectedEnabled && 
	                    // 	!isEdit
	                    // ) {
	                    //     this.beforeEvent(onFocus, this.clear, event);
	                    // }
	                },
	                esc: () => {
	                    this.setState({
	                        dropDownShow: false,
	                        isSelectedShow: false,
	                    });
	                },
	                showHistorySelection: () => {
	                    let { renderInTable } = this.props;
	                    let { referVal } = this.state;
	                    let { isFocusStatus } = this.getStatus();
	                    // if (renderInTable !== true) return;

	                    if (renderInTable) {
	                        //在table中渲染的参照需要按ctrl键时打开历史记录
	                        isFocusStatus &&
								this.setState({ historySelectionVisible: !this.state.historySelectionVisible });
	                    } else {
	                        isFocusStatus && !referVal &&
								this.setState({ dropDownShow: !this.state.dropDownShow });
	                    }
	                },
	            }}
	            attach={document.body}
	            focused={true}
	        />
	    );
	};

	handlePopoverBlur = () => {
	    let { needFocusOnClose, renderInTable } = this.props;
	    this.setState({ isShow: false });

	    if (needFocusOnClose) {
	        let needFocusCell = renderInTable && findParentTd(this.referInput);

	        // 关闭时自动聚焦到当前文本框  去除自动失去焦点 事件 bbqin
	        this.focusFromPopoverBlur = true;
	        this.focusFlag = true;
	        let timer = setTimeout(() => {
	            //弹窗关闭时添加标识，根据这个标识在referInput获取焦点时判断是否需要展示历史搜索记录
	            if (this.referInput) {
	                this.referInput.focus();
	            } else {
	                let cell =
						needFocusCell && needFocusCell.querySelector('div[tabindex="0"]');
	                cell && cell.focus();
	            }
	            clearTimeout(timer);
	        }, 20);
	    } else {
	        setTimeout(() => {
	            this.handleBlurEvent();
	        }, 10);
	    }
	};

	// 过滤禁用数据
	filterDisabledData = data => {
	    let { refType } = this.props;
	    if (Array.isArray(data)) {
	        return data.filter(e => {
	            if (refType === 'tree') {
	                // 排除禁用的节点
	                return !this.isDisabled(e);
	            } else {
	                return true;
	            }
	        });
	    } else {
	        return [];
	    }
	};

	// 数据（树节点）是否被禁用
	isDisabled = item => {
	    let { onlyLeafCanSelect, idKey, refType } = this.props, { keyMap } = this.state;
	    // 从全量数据中找到当前节点，否则isleaf会错乱
	    item = keyMap?.[item[idKey]] ?? item;
	    let disabled = refType === 'tree' && onlyLeafCanSelect && item.isleaf === false;
	    if (!disabled && item.values && item.values.ReturnOnTree) {
	        disabled =
				item.values.ReturnOnTree.display === 'N' ||
				item.values.ReturnOnTree.value === 'N';
	    }
	    return disabled;
	};

	// 点击参照三个点的事件
	show = () => {
	    return null;
	};

	// 渲染：下拉区
	renderDropDown = () => {
	    return null;
	};

	// 渲染：弹出层
	renderPopover = () => {
	    return null;
	};

	// 渲染：弹出层头部
	renderPopoverHeader = () => {
	    return null;
	};

	// 渲染：弹出层头部扩展区
	renderPopoverHeaderExtend = () => {
	    return null;
	};

	// 渲染：弹出层搜索区
	renderPopoverSearchArea = () => {
	    return null;
	};

	// 渲染：弹出层搜索区扩展区
	renderPopoverSearchExtendArea = () => {
	    return null;
	};

	// 渲染：弹出层容器
	renderPopoverContain = () => {
	    return null;
	};

	// 渲染：弹出层容器左侧
	renderPopoverLeft = () => {
	    return null;
	};

	// 渲染：弹出层容器左侧上部
	renderPopoverLeftHeader = () => {
	    return null;
	};

	// 渲染：弹出层右侧
	renderPopoverRight = () => {
	    return null;
	};

	// 渲染：弹出层表格分页区
	renderPopoverPageArea = () => {
	    return null;
	};

	// 渲染：弹出层底部
	renderPopoverBottom = () => {
	    return null;
	};

	// 渲染：弹出层底部扩展区
	renderPopoverBottomExtend = () => {
	    return null;
	};

	render() {
	    let {
	        referVal,
	        loading,
	        dropDownList,
	        selectedValues,
	        jsonInsideRefer,
	        dropDownShow,
	        searchHasMoreData,
	        multiSearch,
	        isSelectedShow,
	    } = this.state;
	    let {
	            disabled,
	            referClassName,
	            className,
	            style,
	            placeholder,
	            dropDownContainer,
	            isMultiSelectedEnabled,
	            onFocus,
	            functions,
	            showTitle,
	            tabIndex,
	            onClick,
	            onEnter,
	            fieldid,
	            attrcode,
	            dropDownPlacement,
	            dropDownTitleConfig,
	            clickContainer,
	            hotKeyWithArrow,
	            searchDataSize,
	            hotDataSize,
	            isShowSelected,
	            isShowSearch,
	            idKey,
	            dropdownClassName, 
	        } = this.props,
	        { isHistoryStatus, isSearchStatus, isSelectedStatus, isFocusStatus } = this.getStatus(),
	        trueValue = [
	            // ...((isSearchStatus && isMultiSelectedEnabled ? selectedValues : this._value) || new Map()).values()
	            ...(
	                (isSelectedStatus || (isSearchStatus && isMultiSelectedEnabled)
	                    ? this.getSelections()
	                    : this._value) || new Map()
	            ).values(),
	        ],
	        firstLabel = this.getDisplayOrValue(trueValue, 'display'),
	        allLabel = trueValue
	            .map(e => this.getDisplayOrValue(e, 'display'))
	            .join(',');
	    dropdownClassName += ' refer-container';
	    let _fieldid = getSysFieldid(fieldid || attrcode);
	    if (_fieldid) {
	        dropdownClassName += ` fieldid_${_fieldid}_refer`;
	    }

	    return (
	        <div
	            className={`refer-wrapper clearfix ${
	                disabled ? 'refer-wrapper-disabled' : ''
	            }`}
	            style={{ display: 'flex' }}
	            fieldid={_fieldid}
	            ref={dom => {
	                this.refer = dom;
	            }}
	        >
	            {this.bindHotKeys({ trueValue })}
	            <Dropdown
	                trigger={['click']}
	                overlayClassName={dropdownClassName}
	                placement={dropDownPlacement}
	                ref={dom => {
	                    this.referContainer = ReactDOM.findDOMNode(dom);
	                }}
	                animation="slide-up"
	                visible={
	                    isHistoryStatus ||
						(isShowSearch && isSearchStatus && !multiSearch) ||
						(isShowSelected && isSelectedStatus)
	                }
	                overlay={(() => {
	                    let columnConfig = dropDownTitleConfig || [
	                            {
	                                name: [
	                                    jsonInsideRefer['containers-refer-0038'], // 编码
	                                    jsonInsideRefer['containers-refer-0039'], // 名称
	                                ],
	                                code: ['refcode', 'refname'],
	                            },
	                        ],
	                        data = (isSelectedStatus
	                            ? this.getSelections()
	                            : this.filterDisabledData(dropDownList.rows)
	                        ).map(item => {
	                            let label = columnConfig[columnConfig.length - 1].code
	                                .map(e => this.getDisplayOrValue(item, e) || '-')
	                                .join('/');
	                            item.label = label;
	                            return item;
	                        }),
	                        title = isSearchStatus
	                            ? // 搜索结果
								  jsonInsideRefer['containers-refer-0034']
	                            : isHistoryStatus
	                                ? // 历史记录
								  jsonInsideRefer['containers-refer-0035']
	                                : isSelectedStatus
	                                    ? // 已选择
								  jsonInsideRefer['containers-refer-0036']
	                                    : '',
	                        noData = [
	                            isSearchStatus
	                                ? // 搜索结果
									  `“${jsonInsideRefer['containers-refer-0034']}”`
	                                : // 历史记录
									  `“${jsonInsideRefer['containers-refer-0035']}”`,
	                            // 暂无数据
	                            <span>{jsonInsideRefer['containers-refer-0041']}</span>,
	                        ],
	                        footer;

	                    if (isHistoryStatus) {
	                        data = data.slice(0, hotDataSize);
	                    } else if (isSearchStatus) {
	                        data = data.slice(0, searchDataSize);
	                    }

	                    if (isSelectedStatus) {
	                        footer = isSelectedStatus && (
	                            <p className="refer-copy">
	                                {/* 复制 */}
	                                <span
	                                    onClick={() => {
	                                        this.hiddenInput.select();
	                                        document.execCommand('Copy');
	                                    }}
	                                >
	                                    {jsonInsideRefer['containers-refer-0037']}
	                                </span>
	                            </p>
	                        );
	                    } else {
	                        footer = data.length && searchHasMoreData && isSearchStatus ? (
	                            <div className="refer-show-more">
	                                <span>
	                                    {/* 点击“ */}
	                                    {jsonInsideRefer['containers-refer-0043']}
	                                    <span className="icon-refer" onClick={this.show} style={{ cursor: 'pointer' }} />
	                                    {/* ”查看更多 */}
	                                    {jsonInsideRefer['containers-refer-0044']}
	                                </span>
	                            </div>
	                                ): null;
	                    }
	                    return (
	                        <DropDownOfRefer
	                            containerDom={this.referContainer}
	                            getStatus={this.getStatus}
	                            selectedValues={selectedValues}
	                            loading={loading}
	                            data={data}
	                            title={title}
	                            columnsTitle={
	                                '（' +
									columnConfig[columnConfig.length - 1].name.join('/') +
									'）'
	                            }
	                            onItemClick={item => {
	                                if (this.getStatus().isFocusStatus) {
	                                    this.focusFlag = true;
	                                    this.singleSelect(item, isSelectedStatus);
	                                    if (isMultiSelectedEnabled) {
	                                        // 这里依赖singleSelect修改了selectedValues的引用，危险
	                                        referVal = this.showCodeIfPossible([...this.state.selectedValues.values()]);
	                                    } else {
	                                        referVal = this.showCodeIfPossible(item);
	                                    }
	                                    this.setState({ referVal });
	                                }
	                            }}
	                            onItemDoubleClick={item => {
	                                if (this.getStatus().isFocusStatus) {
	                                    this.focusFlag = true;
	                                    if (isSearchStatus) {
	                                        let { referVal, selectedValues } = this.state;
	                                        if (isMultiSelectedEnabled) {
	                                            selectedValues.set(item.refpk, item);
	                                            referVal = this.showCodeIfPossible([...selectedValues.values()]);
	                                        } else {
	                                            referVal = this.showCodeIfPossible(item);
	                                        }
	                                        this.setState({ referVal }, () => {
												this.referInput?.blur();
												this.referInput?.focus();
	                                        });
	                                    } else if (isHistoryStatus) {
	                                        this.singleSelect(item, isSelectedStatus);
	                                        this.setState({ referVal: this.showCodeIfPossible(item) });
	                                    }
	                                }
	                            }}
	                            // onEnter 回调 bbqin
	                            onEnter={onEnter}
	                            noData={noData}
	                            footer={footer}
	                            isMultiSelectedEnabled={isMultiSelectedEnabled}
	                            width={this.referContainer && this.referContainer.offsetWidth}
	                            renderInTable={this.props.renderInTable}
	                            dropDownShow={dropDownShow}
	                            searchKey={referVal}
	                            hotKeyWithArrow={hotKeyWithArrow}
	                        />
	                    );
	                })()}
	                getPopupContainer={() => typeof dropDownContainer === 'function' ? dropDownContainer() : dropDownContainer}
	            >
	                {clickContainer ? (
	                    cloneElement(clickContainer, {
	                        onClick: event => {
	                            this.run(clickContainer.props.onClick, event);
	                            this.beforeEvent(onFocus, this.show, event);
	                        },
	                        className: ' refer-click-container',
	                    })
	                ) : (
	                    <Col
	                        xs={12}
	                        className={`refer clearfix ${referClassName}  ${perceptionInputContainerClass(
	                            disabled,
	                            this.focusFlag,
	                        )}`}
	                        style={{ ...style }}
	                        onClick={() => {
	                            this.referInput && this.referInput.focus();
	                        }}
	                    >
	                        <div title={showTitle ? allLabel : ''}>
	                            <ul
	                                onClick={() => {
										this.referInput?.focus();
	                                }}
	                            >
	                                {/* <TagGroup 
	                                    onFocus={this.handleInput} 
	                                    isMultiSelectedEnabled={isMultiSelectedEnabled} 
	                                    onChange={this.handleInput} 
	                                    onBlur={this.close}
	                                    disabled={!!disabled}
	                                /> */}
	                                <li
	                                    style={{
	                                        display:
											!isFocusStatus && isMultiSelectedEnabled && trueValue.length
												    ? 'inline-block'
												    : 'none',
	                                    }}
	                                    className={`selected-item single-select`}
	                                    onClick={event => {
	                                        this.beforeEvent(onFocus, () => {
	                                            this.handleInputClick();
	                                        }, event);
	                                    }}
	                                >
	                                    <span>{firstLabel}</span>
	                                </li>
	                                {/* {!isEdit && trueValue.length > 1 ? (
	                                    <li className="selected-num" >
											+{trueValue.length - 1}
	                                    </li>
	                                ) : null} */}
	                                <li
	                                    className={`selected-input ${
	                                        !isFocusStatus && isMultiSelectedEnabled && trueValue.length > 0
	                                            ? 'selected-input-hidden'
	                                            : ''
	                                    }`}
	                                >
	                                    <input
	                                    	// 用于复制
	                                        type="text"
	                                        ref={dom => {
	                                            this.hiddenInput = dom;
	                                        }}
	                                        value={allLabel}
	                                        readOnly
	                                        className="hidden-input"
	                                        tabIndex="-1"
	                                    />
	                                    <FormControl
	                                        ref={dom => {
	                                            this.referInput = ReactDOM.findDOMNode(dom);
	                                            this.referInput =
													this.referInput &&
													this.referInput.querySelector('input');
	                                        }}
	                                        className={`refer-input ${className}`}
	                                        disabled={!!disabled}
	                                        value={referVal || ''}
	                                        onClick={event => {
	                                            this.beforeEvent(onFocus, () => {
	                                                this.handleInputClick();
	                                            }, event);

	                                            event.stopPropagation();
	                                            event.target.focus();
	                                            typeof onClick === 'function' && onClick(event);
	                                            let ncc_automated = getGlobalStorage('localStorage', '_ncc_automated_');
	                                			if (ncc_automated == '1') {
	                                                // 自动化测试开关打开
	                                                this.handleInput(event.target.value, { searchNow: true });
	                                            }
	                                        }}
	                                        onChange={value => {
	                                            let ncc_automated = getGlobalStorage('localStorage', '_ncc_automated_');
	                                            // 自动化测试开关关闭
	                                            this.handleInput(value, { searchNow: ncc_automated != '1' });
	                                        }}
	                                        // onEnter 回调 bbqin
	                                        onEnter={({ e }) => {
	                                            // 处理掉一部分  状态不显示情况触发不了onEnter  state.dropDownShow 并不能作为下拉的状态判断
	                                            let noShow =
														!(
														    isHistoryStatus ||
															isSearchStatus ||
															isSelectedStatus
														) || !this.state.dropDownShow,
	                                                target = e.target;

	                                            let timer = setTimeout(() => {
	                                                this.hotKeyClose = false;
	                                                // 弹窗如果没有关闭阻止  onEnter 跳转
	                                                !this.state.isShow &&
														noShow &&
														onEnter &&
														onEnter({
														    e,
														    target,
														    eventKey: 'Enter',
														});
	                                                clearTimeout(timer);
	                                            }, 20);
	                                        }}
	                                        hotKeyWithArrow={({ e }) => {
	                                            let { historySelectionVisible } = this.state;
	                                            let status = {
	                                                isHistoryStatus,
	                                                isSearchStatus,
	                                                isSelectedStatus,
	                                                historySelectionVisible,
	                                            };
	                                            handleArrowKeyDown({
	                                                context: this,
	                                                callBack: hotKeyWithArrow,
	                                                e,
	                                                status,
	                                            });
	                                        }}
	                                        onMouseDown={() => {
	                                            this.referInputMouseDown = true;
	                                        }}
	                                        onFocus={event => {
	                                            let { showCodeWhenFocus, fieldValued } = this.props;
												let trueValue = [...this.getSelections().values()];
	                                            let input = event.target, referInputMouseDown = this.referInputMouseDown;
	                                            if (showCodeWhenFocus && fieldValued === 'refpk' && trueValue.length) {
	                                                // 查已选数据，显示编码
	                                                // 没有code的时候才查
	                                                // if (trueValue.some(e => !e.refcode)) {
	                                                    let result = this.loadSelectedData(trueValue, { shouldUpdate: false });
	                                                    if (result.length) {
	                                                        trueValue = result;
	                                                        let selectedValues = new Map(result.map(e => [e[idKey], e]));
	                                                        // TODO:保证willReceiveProps里拿到的是新的，待优化
	                                                        this.state.selectedValues = selectedValues;
	            											this.setState({ selectedValues });
	                                                    }
	                                                // }
	                                                let referVal = this.getDisplayOrValue(trueValue, 'refcode') || this.getDisplayOrValue(trueValue, 'display');
											
	                                                this.setState({ referVal }, () => {
	                                                    input.setSelectionRange(0, referVal.length);
	                                                });
	                                            } else {
	                                                input.setSelectionRange(0, referVal.length);
	                                            }

	                                            if (this.focusFromPopoverBlur) {
	                                                this.focusFromPopoverBlur = false;
	                                            } else {
	                                                this.beforeEvent(onFocus, (...rest) => {
	                                                    if (this.autoFocus) {
	                                                        // autoFocus时延迟执行，否则this.referInput为空导致handleInput提前return
	                                                        setTimeout(() => {
	                                                            this.handleFocus(...rest);
	                                                        }, 0);
	                                                    } else {
	                                                        this.handleFocus(...rest);
	                                                    }
	                                                }, event, { fromFocus: true });
	                                            }
	                                        }}
	                                        onMouseUp={() => {
	                                            this.referInputMouseDown = false;
	                                        }}
	                                        placeholder={
	                                            (this.state.isShow
	                                                ? [...(this._value || new Map()).values()]
	                                                : this.getSelections()
	                                            ).length
	                                                ? ''
	                                                : placeholder
	                                        }
	                                        autoFocus={this.autoFocus}
	                                        tabIndex={tabIndex}
	                                        onBlur={this.close}
	                                        maxLength={Infinity}
	                                        // maxLength={finalMaxLength}
	                                        renderInTable={this.props.renderInTable}
	                                        onKeyDown={e => {
	                                            let status = this.getStatus();
	                                            this.props.onKeyDown({
	                                                e,
	                                                status,
	                                            });
	                                            if (
	                                                status.isSearchStatus &&
													(e.keyCode === 38 || e.keyCode === 40)
	                                            ) {
	                                                // 禁用上下键防止光标跳动
	                                                e.preventDefault();
	                                            }
	                                            if (e.keyCode === 188) {
	                                                // 逗号
													
	                                            }
	                                        }}
	                                        itemtype="refer"
	                                        onPaste={event => {
	                                            // 表格中会影响默认的粘贴事件 去除
	                                            if (this.props.renderInTable) {
	                                                return;
	                                            }
	                                            if (disabled) {
	                                                return;
	                                            }
	                                            event.preventDefault();
	                                            let paste = (event.clipboardData || window.clipboardData).getData('text');
	                                            paste = paste.replace(/\r|^\s*|\s*$/g, '');
	                                            if (isMultiSelectedEnabled) {
	                                                // 多选换行改逗号
	                                                paste = paste.replace(/\n/g, ',') ?? '';
	                                            } else {
	                                                // 单选取第一行（配合表格粘贴）
	                                                paste = paste.split(/[\n]/g)[0] ?? '';
	                                            }
	                                            let ncc_automated = getGlobalStorage('localStorage', '_ncc_automated_');
	                                            // 自动化测试开关关闭
	                                            let selectionStart = event.target.selectionStart;
	                                            let selectionEnd = event.target.selectionEnd;
	                                            paste = referVal.slice(0, selectionStart) + paste + referVal.slice(selectionEnd);
	                                            this.handleInput(paste, { searchNow: ncc_automated != '1' });
	                                        }}
	                                    />
	                                </li>
	                            </ul>
	                        </div>
	                        {(isFocusStatus ? referVal : firstLabel) && (
	                            <i
	                                className={"refer-del-i iconfont icon-qingkong" + (disabled ? ' icon-hidden' : '')}
	                                onClick={event => {
	                                    event.stopPropagation();
	                                    typeof onClick === 'function' && onClick(event);
	                                    this.beforeEvent(onFocus, this.clear, event);
	                                }}
	                                onMouseDown={e => {
	                                    e.preventDefault();
	                                }}
	                            />
	                        )}
	                        <span
	                            className="icon-refer"
	                            style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
	                            onMouseDown={e => {
	                                e.preventDefault();
	                            }}
	                            onClick={event => {
	                                event.stopPropagation();
	                                typeof onClick === 'function' && onClick(event);
	                                this.beforeEvent(
	                                    onFocus,
	                                    this.show,
	                                    event,
	                                    { fromIconRefer: true },
	                                );
	                            }}
	                        />
	                    </Col>
	                )}
	            </Dropdown>
	            {Array.isArray(functions) && functions.length ? (
	                <Dropdown
	                    trigger={['click']}
	                    overlayClassName={
	                        getSysFieldid('fieldid_function_refer')
	                            ? 'fieldid_function_refer refer-function-dropdown'
	                            : 'refer-function-dropdown'
	                    }
	                    placement="bottomLeft"
	                    overlay={
	                        <ul>
	                            {functions.map(e => (
	                                <li key={e.name} onClick={this.onFunctionClick.bind(this, e)}>{e.name}</li>
	                            ))}
	                        </ul>
	                    }
	                    overlayStyle={{ display: disabled && 'none' }}
	                >
	                    <span
	                        className={`refer-function ${
	                            disabled ? 'refer-function-disabled' : 'refer-function-common'
	                        }`}
	                        onClick={onClick}
	                    >
							fx
	                    </span>
	                </Dropdown>
	            ) : null}
	            {this.renderDropDown()}
	            {this.renderPopover()}
	        </div>
	    );
	}
}

BaseRefer.propTypes = {
    value: PropTypes.oneOfType([PropTypes.object, PropTypes.array]), // 参照的值
    foolValue: PropTypes.object, // {display, value}的值
    onChange: PropTypes.func, // onChange事件
    extraOnChange: PropTypes.func, // 额外的onChange事件——sunzg
    refName: PropTypes.string, // 参照名称
    refName_db: PropTypes.string, // 后台参照名称——wpz
    refType: PropTypes.oneOf(['tree', 'grid', 'gridTree']), // 参照类型
    type: PropTypes.oneOf(['dropDown', 'popover']), // 参照展示类型
    columnConfig: PropTypes.array, // 列信息配置
    treeConfig: PropTypes.object, // 树信息配置
    hotDataSize: PropTypes.number, // 历史记录条数
    searchDataSize: PropTypes.number, // 搜索结果条数
    pageSize: PropTypes.number, // 分页请求数据时每页条数
    disabled: PropTypes.bool, // 是否禁用
    referClassName: PropTypes.string, // 参照最外层classname
    className: PropTypes.string, // 参照input的classname
    style: PropTypes.object, // 参照最外层样式
    placeholder: PropTypes.string, // 占位文字
    showHistory: PropTypes.bool, // 是否显示历史记录
    queryGridUrl: PropTypes.string, // 查询表格数据的url
    queryTreeUrl: PropTypes.string, // 查询树数据的url
    clickContainer: PropTypes.object, // 可以触发参照弹窗事件的容器
    queryCondition: PropTypes.oneOfType([PropTypes.func, PropTypes.object]), // 自定义查询条件，会传到后台
    isCacheable: PropTypes.bool, // 是否启用数据缓存
    container: PropTypes.object, // 容器
    dropDownContainer: PropTypes.object, // 下拉的容器
    isMultiSelectedEnabled: PropTypes.bool, // 是否多选
    onTreeNodeExpand: PropTypes.func, // 树节点展开事件
    maxCacheNum: PropTypes.number, // 缓存条数
    rootNode: PropTypes.object, // 树的根节点
    autoFocus: PropTypes.bool, // 自动获取焦点
    onBlur: PropTypes.func, // 失去焦点事件
    onFocus: PropTypes.func, // 获取焦点事件
    onlyLeafCanSelect: PropTypes.bool, // 是否只有树节点可选
    isTreelazyLoad: PropTypes.bool, // 树是否懒加载
    allowSearchConfig: PropTypes.bool, // 是否启用搜索设置
    allowColumnConfig: PropTypes.bool, // 是否启用列设置
    fieldDisplayed: PropTypes.string, // 作为display的字段
    fieldValued: PropTypes.string, // 作为value的字段
    isShowDisabledData: PropTypes.bool, // 显示停用
    isHasDisabledData: PropTypes.bool, // 是否有【显示停用】功能
    unitProps: PropTypes.object, // 业务单元参照的属性
    unitCondition: PropTypes.oneOfType([PropTypes.func, PropTypes.object]), // 业务单元参照的过滤条件
    isShowUnit: PropTypes.bool, // 业务单元参照的属性
    checkStrictly: PropTypes.bool, // 检验值的准确性（必须是后台有的值）
    popWindowClassName: PropTypes.string, // 添加到弹出层的class
    idKey: PropTypes.string, // 树id对应的key值
    pidKey: PropTypes.string, // 树pid对应的key值
    rowKey: PropTypes.string, // 表格的rowKey值
    isShowUsual: PropTypes.bool, // 是否显示常用
    defaultUnitValue: PropTypes.object, // 业务单元默认值
    isShowTableSearch: PropTypes.bool, // 显示表格区的搜索框
    isShowTreeSearch: PropTypes.bool, // 显示树区的搜索框
    functions: PropTypes.array, // 参照函数
    showTitle: PropTypes.bool, // 鼠标悬停是否显示title
    isRunWithChildren: PropTypes.bool, // 是否启用【执行时包含下级】功能
    isAlwaysEmitOnChange: PropTypes.bool, // 是否始终触发编辑后事件
    unitValueIsNeeded: PropTypes.bool, // 只有选业务单元才会发请求
    tabIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    baseTabIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // tabIndex基于此值往上加
    inputDefer: PropTypes.number, // 输入后触发事件的延迟时间
    onClick: PropTypes.func,
    needFocusOnClose: PropTypes.bool, // 关闭后是否需要获取焦点
    dropDownPlacement: PropTypes.string, // 关闭后是否需要获取焦点
    dropDownTitleConfig: PropTypes.object, // 关闭后是否需要获取焦点
    maxChoice: PropTypes.number, // 最多选择的数据条数
    async: PropTypes.bool, // 请求是否异步
    searchWithKeywordOutsideWhenOpen: PropTypes.bool, // 打开界面时根据外部输入框的搜索关键字进行搜索结果的展示
    selectFirstTreeNodeWhenOpen: PropTypes.bool, // 树表参照打开时是否选中第一个树节点并查右表
    queryCommonUseWhenOpen: PropTypes.bool, // 打开时是否查常用
    fieldSplitSep: PropTypes.string, // 多字段显示时，用来分割的分隔符，适用于fieldDisplayed和fieldValued
    fieldJoinSep: PropTypes.string, // 多字段显示时，用来连接的分隔符，适用于display和value
    usualDataSize: PropTypes.number, // 常用数据最大条数
    onKeyDown: PropTypes.func, // 键盘事件
    isQuerySelectedData: PropTypes.bool, // 点已选时是否走后台查询已选数据
    needQuerySelectedDataBeforeOnChange: PropTypes.bool, // 触发onChange之前是否走后台查询已选数据
    isShowSelected: PropTypes.bool, // 是否显示已选下拉
    isShowSearch: PropTypes.bool, // 是否显示搜索下拉
    defaultIncludeChildren: PropTypes.bool, // 默认勾选【包含下级】
    defaultRunWithChildren: PropTypes.bool, // 默认勾选【执行时包含下级】
    extraParam: PropTypes.oneOfType([PropTypes.object, PropTypes.func]), // 发请求时的额外参数
    hasAddButton: PropTypes.bool, // 是否有新增按钮
    addButtons: PropTypes.array, // 新增按钮列表
    scrollSelectedNodeIntoView: PropTypes.bool, // 将选中的节点展示在视图中
    clearUnitValueWhenOpen: PropTypes.bool, // 打开参照时清空业务单元的值
    defaultMax: PropTypes.bool, // 默认最大化展示
    treeWidth: PropTypes.string, // 树表参照左树默认宽度
    expandAllNodeWhenFirstOpen: PropTypes.bool, // 属性参照默认展开全部
    isBlurSearch: PropTypes.bool, // 失去焦点时搜索
    selectRootNodeWhenGridTreeReferSearch: PropTypes.bool, // 树表参照搜索时是否选择根节点
    useLoading: PropTypes.bool, // 发起请求时是否有loading
    pageSizeOptions: PropTypes.array, // 表格分页可以选每页大小配置
    showCodeWhenFocus: PropTypes.bool, // 参照获取焦点时显示编码
    dropdownClassName: PropTypes.string, // 参照下拉className
    searchTrigger: PropTypes.string, // 触发弹窗内搜索的事件
    showClassification: PropTypes.bool, // 是否显示所属分类
    rootNodeSelectable: PropTypes.bool, // 根节点是否可点击
	selectRootNodeWhenFirstOpen: PropTypes.bool, // 根节点可点击时直接选中根节点
};

BaseRefer.defaultProps = {
    foolValue: null, // {display, value}格式的值
    refName: '', // 参照名称
    refName_db: '', // 后台参照名称
    refType: 'grid', // 参照类型
    type: 'popover', // 参照展示类型
    columnConfig: [
        {
            name: [
                '编码',
                // (jsonInsideRefer || {})['containers-refer-0038'],
                '名称',
                // (jsonInsideRefer || {})['containers-refer-0039']
            ],
            code: ['refcode', 'refname'],
        },
    ], // 列信息配置
    treeConfig: {
        // 名称
        name: [
            '名称',
            // (jsonInsideRefer || {})['containers-refer-0039']
        ],
        code: ['refname'],
    }, // 树信息配置
    hotDataSize: 10, // 历史记录条数
    searchDataSize: 100, // 搜索结果条数
    pageSize: 50, // 分页请求数据时每页条数
    disabled: false, // 是否禁用
    referClassName: '', // 参照最外层classname
    className: '', // 参照input的classname
    style: {}, // 参照最外层样式
    placeholder: '', // 占位文字
    showHistory: true, // 是否显示历史记录
    queryGridUrl: '', // 查询表格数据的url
    queryTreeUrl: '', // 查询树数据的url
    clickContainer: null, // 可以触发参照弹窗事件的容器
    queryCondition: null, // 自定义查询条件，会传到后台
    isCacheable: true, // 是否启用数据缓存
    container: document.body, // 容器
    dropDownContainer: document.body, // 容器
    isMultiSelectedEnabled: false, // 是否多选
    onTreeNodeExpand() {}, // 树节点展开事件
    maxCacheNum: 10, // 缓存条数
    // 根节点
    rootNode: { refname: '根节点', refpk: 'root' },
    autoFocus: false, // 自动获取焦点
    onBlur: null, // 失去焦点事件
    onFocus: null, // 获取焦点事件
    onlyLeafCanSelect: false, // 是否只有树节点可选
    isTreelazyLoad: false, // 树是否懒加载
    allowSearchConfig: true, // 是否启用搜索设置
    allowColumnConfig: true, // 是否启用列设置
    fieldDisplayed: 'refname', // 作为display的字段
    fieldValued: 'refpk', // 作为value的字段
    isShowDisabledData: false, // 显示停用
    isHasDisabledData: true, // 是否有【显示停用】功能
    unitProps: null, // 业务单元参照的属性
    isShowUnit: false, // 是否显示业务单元（前提是unitProps不为null）
    checkStrictly: true, // 检验值的准确性（必须是后台有的值）
    popWindowClassName: '', // 添加到弹出层的class
    idKey: 'refpk', // 树id对应的key值
    pidKey: 'pid', // 树pid对应的key值
    rowKey: 'refpk', // 表格的rowKey值
    isShowUsual: false, // 是否显示常用
    defaultUnitValue: {}, // 业务单元默认值
    isShowTableSearch: true, // 显示表格区的搜索框
    isShowTreeSearch: true, // 显示树区的搜索框
    functions: [], // 参照函数
    showTitle: true, // 鼠标悬停是否显示title
    isRunWithChildren: false, // 是否启用【执行时包含下级】功能
    isAlwaysEmitOnChange: false, // 是否始终触发编辑后事件
    unitValueIsNeeded: false, // 只有选业务单元才会发请求
    tabIndex: 0,
    baseTabIndex: 0, // tabIndex基于此值往上加
    inputDefer: 500, // 输入后触发事件的延迟时间
    onClick() {},
    needFocusOnClose: true, // 关闭后是否需要获取焦点
    dropDownPlacement: 'bottomLeft',
    dropDownTitleConfig: null,
    maxChoice: Infinity,
    async: true, // 请求是否异步
    searchWithKeywordOutsideWhenOpen: true, // 打开界面时根据外部输入框的搜索关键字进行搜索结果的展示
    selectFirstTreeNodeWhenOpen: true, // 树表参照打开时是否选中第一个树节点并查右表
    queryCommonUseWhenOpen: true, // 打开时是否查常用
    fieldSplitSep: '/', // 多字段显示时，用来分割的分隔符，适用于fieldDisplayed和fieldValued
    fieldJoinSep: '/', // 多字段显示时，用来连接的分隔符，适用于display和value
    usualDataSize: 200, // 常用数据最大条数
    onKeyDown() {}, //input keyDown 事件
    isQuerySelectedData: true, // 点已选时是否走后台查询已选数据
    needQuerySelectedDataBeforeOnChange: false, // 触发onChange之前是否走后台查询已选数据
    isShowSelected: true, // 是否显示已选下拉
    isShowSearch: true, // 是否显示搜索下拉
    defaultIncludeChildren: false, // 默认勾选【包含下级】
    defaultRunWithChildren: false, // 默认勾选【执行时包含下级】
    extraParam: {}, // 发请求时的额外参数
    hasAddButton: false, // 是否有新增按钮
    addButtons: [], // 新增按钮列表
    scrollSelectedNodeIntoView: true, // 将选中的节点展示在视图中
    clearUnitValueWhenOpen: false, // 打开参照时清空业务单元的值
    defaultMax: false, // 默认最大化展示
    treeWidth: '240px', // 树表参照左树默认宽度
    expandAllNodeWhenFirstOpen: false, // 属性参照默认展开全部
    isBlurSearch: true, // 失去焦点时搜索
    selectRootNodeWhenGridTreeReferSearch: true, // 树表参照搜索时是否选择根节点
    useLoading: false, // 发起请求时是否有loading
    pageSizeOptions: [50, 100, 200, 500], // 表格分页可以选每页大小配置
    showCodeWhenFocus: true, // 参照获取焦点时显示编码
    dropdownClassName: '', // 参照下拉className
    searchTrigger: 'input', // 触发弹窗内搜索的事件
    showClassification: true, // 是否显示所属分类
    rootNodeSelectable: false, // 根节点是否可点击
	selectRootNodeWhenFirstOpen: false, // 根节点可点击时直接选中根节点
};

export default BaseRefer;
